import React, { Component } from "react";
import { Row, Col, Card, Table, Button, Modal, ModalHeader } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import { URL,  fotoStyle } from "../../redux/actions/constants";
import noImg from "../../images/no-img.png";

class TransferStockDetail extends Component {
  state = {
    pageTitle: "Stok Aktarım Detay",
    pageTitleDetail: "Stok Aktarım Detay",
    pageAddLink: "stok-aktarim-ekle",
    pageListLink: "stok-aktarim-listele",
    breadcrumb: [{ text: "Stok Aktarım", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    locationName: "",
    locationGuid: null,
    transferLocationName: "",
    transferStockProductDto: [],
    totalPiece: "",
    productName: "",
    piece: null,
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedByF: "",
    isOpen: false,
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/transferStocks/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            transferStockProductDto: response.data.transferStockProductDto,
            locationName: response.data.locationName,
            locationGuid: response.data.locationGuid,
            transferLocationName: response.data.transferLocationName,
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  toggle = (image, name) => {
    this.setState({
      isOpen: !this.state.isOpen,
      image: image,
      name: name,
    });
  };

  render() {
    let _self = this;

    const mainRow = {
      backgroundColor: "#1d4b8c",
      color: "#fff",
    };
    const subRow = {
      backgroundColor: "#f2f2f2",
    };

    const thStyle = {
      width: "400px",
      textAlign: "left",
    };

    const thStyle2 = {
      width: "150px",
      textAlign: "center",
    };

    const thStyle3 = {
      width: "50px",
    };

    const tdStyle = {
      textAlign: "left",
      paddingTop: "23px",
    };

    const tdStyle2 = {
      textAlign: "center",
      width: "100px",
      paddingTop: "23px",
    };

    const tdStyle3 = {
      width: "50px",
    };

    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}

              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Depo</th>
                    <td colSpan="4">{this.state.locationName}</td>
                  </tr>
                  <tr>
                    <th>Aktarılan Depo</th>
                    <td colSpan="4">{this.state.transferLocationName}</td>
                  </tr>
                  <tr>
                    <th>Ekleyen Kullanıcı</th>
                    <td colSpan="4">{this.state.createdBy}</td>
                  </tr>
                  <tr>
                    <th>Eklenen Tarih</th>
                    <td colSpan="4">{this.state.createdAt}</td>
                  </tr>
                </tbody>
              </Table>

              {this.state.transferStockProductDto !== null &&
                this.state.transferStockProductDto.length > 0 && (
                  <Row>
                    <Col lg="8">
                      <Table className="table table-responsive table-hover table-product">
                        <tr style={mainRow}>
                          <th style={thStyle3}>Fotoğraf</th>
                          <th style={thStyle}>Ürün Adı</th>
                          <th style={thStyle2} className="text-center">
                            Sağlam Adet
                          </th>
                          <th style={thStyle2} className="text-center">
                            Arızalı Adet
                          </th>
                          <th style={thStyle2} className="text-center">
                            Toplam Adet
                          </th>
                        </tr>
                        {this.state.transferStockProductDto.map(function (
                          item
                        ) {
                          return (
                            <tr style={subRow}>
                              <td style={tdStyle3}>
                                {item.machineProductImage ? (
                                  <Button
                                    onClick={() =>
                                      _self.toggle(
                                        item.machineProductImage,
                                        item.machineProductName
                                      )
                                    }
                                    className="modalButtonList"
                                  >
                                    <img
                                      alt={item.machineProductName}
                                      src={`/Images/${item.machineProductImage}`}
                                      className="rdt_image table-image"
                                    />
                                  </Button>
                                ) : (
                                  <img
                                    alt={item.name}
                                    src={noImg}
                                    className="rdt_image rdt_no_image table-image"
                                  />
                                )}
                              </td>
                              <td style={tdStyle}>{item.machineProductName}</td>
                              <td style={tdStyle2} className="text-center">
                                {item.pieceDurable}
                              </td>
                              <td style={tdStyle2} className="text-center">
                                {item.pieceDefective}
                              </td>
                              <td style={tdStyle2} className="text-center">
                                {item.piece}
                              </td>
                            </tr>
                          );
                        })}
                      </Table>
                    </Col>
                  </Row>
                )}
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
        <Modal
          className="modal-xs"
          isOpen={this.state.isOpen}
          toggle={this.toggle}
        >
          <ModalHeader toggle={this.toggle}></ModalHeader>
          <img
            className="modalImage"
            src={`/Images/${this.state.image}`}
            style={fotoStyle}
            alt={this.state.name}
          />
        </Modal>
      </>
    );
  }
}

export default TransferStockDetail;
